import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { Form, useNotify, useEditContext } from 'react-admin';
import { OpenWith } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { updateTerminalStatus } from '../../../services/Terminal';
import Color from '../../layout/color/Color';

export default function TerminalOpenButton() {
  const { record } = useEditContext();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();
  const navigate = useNavigate();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      await updateTerminalStatus(record.id, 2, password);
      notify(`Request successfully, waiting for approve.`, { type: 'success' });

      setIsLoading(false);
      setOpen(false);
      navigate('/Terminal');
    } catch (error) {
      notify(`Incorrect password!`, { type: 'error' });
      setIsLoading(false);
    }
  };

  if (!record || record.id == null) {
    return null;
  }

  return (
    <>
      <Button
        size="large"
        onClick={handleOpen}
        startIcon={<OpenWith />}
        color="info"
        variant="outlined"
      >
        Open
      </Button>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle align="center" variant="h5" fontWeight="bold">
          Open terminal?
        </DialogTitle>
        <Form onSubmit={handleSubmit}>
          <Box pl="3rem" pr="3rem">
            <FormControl>
              <Typography variant="h6" align="center">
                Are you sure to open this terminal?
              </Typography>
              <Typography variant="body1" align="center">
                Please enter password to comfirm.
              </Typography>
              <TextField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                label="Password"
                variant="outlined"
                placeholder="Password"
                fullWidth
                type="password"
                required
                sx={{ mt: '15px' }}
              />
              <br />
            </FormControl>
          </Box>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="contained"
              color="inherit"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <LoadingButton
              autoFocus
              sx={{ color: Color.Button, bgcolor: Color.Main }}
              variant="contained"
              loading={isLoading}
              type="submit"
            >
              Confirm
            </LoadingButton>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
